import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import TrustBar from '../../components/feature/TrustBar';
import PlatformPartners from '../../components/feature/PlatformPartners';
import AIAnswerBlock from '../../components/feature/AIAnswerBlock';
import Process from '../../components/feature/Process';
import WhyChooseUs from '../../components/feature/WhyChooseUs';
import ServiceAreas from '../../components/feature/ServiceAreas';
import Testimonials from '../../components/feature/Testimonials';
import FAQ from '../../components/feature/FAQ';
import FinalCTA from '../../components/feature/FinalCTA';
import Hero from './components/Hero';
import ServicesOverview from './components/ServicesOverview';

export default function Home() {
  return (
    <main>
      <Navbar />
      <Hero />
      <TrustBar />
      <PlatformPartners />
      <ServicesOverview />
      <AIAnswerBlock />
      <Process />
      <WhyChooseUs />
      <ServiceAreas />
      <Testimonials />
      <FAQ />
      <FinalCTA />
      <Footer />
    </main>
  );
}
